import { type FunctionComponent } from 'preact'
import { html } from 'htm/preact'
import type { AppState } from '../state.js'

export const PrivacyRoute:FunctionComponent<{ state:AppState }> =
function PrivacyRoute () {
    return html`<div class="route privacy">
        <h2>Privacy Policy</h2>
        <p class="legal-updated">Last updated: June 27, 2026</p>

        <p>
            This policy explains what information hvaclog collects when
            you use this website and its free tools, and how we use it.
        </p>

        <h3>Information we collect</h3>
        <ul>
            <li>
                <strong>Email address.</strong> We only collect your
                email if you choose to give it to us, for example by
                signing up to be notified about product updates.
            </li>
            <li>
                <strong>Usage and diagnostic data.</strong> We use a
                third-party error-monitoring service to detect and fix
                problems and improve the site. This may include your IP
                address and a record of how you interact with pages.
            </li>
            <li>
                <strong>Tool inputs.</strong> The free calculators run
                entirely in your browser. The values you type into them
                are not sent to or stored by us.
            </li>
        </ul>

        <h3>How we use information</h3>
        <ul>
            <li>To send you the updates you asked to receive.</li>
            <li>To diagnose, fix, and prevent technical problems.</li>
            <li>To understand usage and improve the tools.</li>
        </ul>

        <h3>How we share information</h3>
        <p>
            We do not sell your personal information. We share data only
            with the service providers that help us operate this site
            (such as hosting and error monitoring), and when we are
            required to by law.
        </p>

        <h3>Cookies and local storage</h3>
        <p>
            This site uses your browser's local storage for basic
            functionality. We do not use advertising cookies.
        </p>

        <h3>Your choices</h3>
        <p>
            You can ask us to remove your email address from our list at
            any time by contacting us at
            ${' '}<a href="mailto:mail@hvaclogsystem.com">
                mail@hvaclogsystem.com</a>.
        </p>

        <h3>Contact</h3>
        <p>
            Questions about this policy? Email
            ${' '}<a href="mailto:mail@hvaclogsystem.com">
                mail@hvaclogsystem.com</a>.
        </p>

        <p class="legal-note">
            This page is a general template provided for convenience and
            is not legal advice. Consult a qualified professional to
            confirm it fits your situation.
        </p>
    </div>`
}
